import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";

const RESPONSIVE_TOOLTIP_POPPER_CONFIG = {
  strategy: "fixed",
  modifiers: [
    {
      name: "flip",
      options: {
        fallbackPlacements: ["left", "bottom", "top"],
      },
    },
    {
      name: "preventOverflow",
      options: {
        boundary: "viewport",
        padding: 8,
      },
    },
  ],
};

const InfoTooltipIcon = ({
  ariaLabel,
  className = "text-secondary ml-1",
  placement = "right",
  text,
}) => (
  <Tooltipable
    text={text}
    trigger="click"
    placement={placement}
    tooltipContentClassName="text-left text-white"
    popperConfig={RESPONSIVE_TOOLTIP_POPPER_CONFIG}
  >
    <button
      type="button"
      aria-label={ariaLabel}
      className="bg-transparent border-0 p-0 d-inline-flex align-items-center"
      style={{ lineHeight: 1 }}
    >
      <FontAwesomeIcon
        icon={["fal", "fa-info-circle"]}
        size="sm"
        style={{ fontSize: ".6em" }}
        className={className}
      />
    </button>
  </Tooltipable>
);

InfoTooltipIcon.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  placement: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default InfoTooltipIcon;
